<template>
  <v-card-text>
    <v-row>
      <v-col>
        <v-card outlined class="pa-4">
          <h3>Especificações de produção</h3>
          <div v-html="specifications"></div>
        </v-card>
      </v-col>
    </v-row>
  </v-card-text>
</template>
<script>
export default {
    props: {
        item: Object
    },
    computed: {
        specifications(){
            return this.item.asus.manufacturing_specification.replace(/\n/g, '<br>')
        }
    }
}
</script>